import React, { useEffect, useState } from 'react';
import Modal from '../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import Loading from '../../../../Components/Loading';
import NoEscape from '../../../../Components/NoEscape';

interface Props {
  opened: boolean;
  onClose: () => void;
  content: string;
  title: string;
}

const NcziHtmlModalViewer: React.FC<Props> = props => {
  const { opened, onClose, title, content } = props;
  const { isCase } = useTreatmentContext();

  return (
    <Modal
      opened={opened}
      onClose={() => onClose()}
      fullScreen={false}
      wrapChat={isCase}>
      <Modal.Header title={title} firstUpper />
      <Modal.Content>
        <div style={{width: '900px'}}>
          <NoEscape>{content}</NoEscape>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default NcziHtmlModalViewer;
